import { SvgIcon, SvgIconProps } from '@mui/material';

const TrailingArrow = ({ viewBox = '0 0 24 24', ...props }: SvgIconProps) => (
  <SvgIcon
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 24, fill: 'none', ...props.sx }}
    data-testid="trailingArrowIcon"
  >
    <path
      d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
      fill="#0B1421"
      fillOpacity="0.1"
    />
    <path
      d="M13.2826 12L9.55157 15.7155C9.13945 16.126 9.13945 16.7914 9.55157 17.2018C9.96369 17.6122 10.6319 17.6122 11.044 17.2018L15.3969 12.867C15.8777 12.3882 15.8777 11.6118 15.3969 11.133L11.044 6.79823C10.6319 6.38783 9.96369 6.38783 9.55157 6.79823C9.13945 7.20864 9.13945 7.87404 9.55157 8.28445L13.2826 12Z"
      fill="#0B1421"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7452 10.7863C16.4183 11.4566 16.4183 12.5434 15.7451 13.2137L11.3922 17.5486C10.7878 18.1505 9.80778 18.1505 9.20334 17.5486C8.59889 16.9466 8.59889 15.9707 9.20334 15.3688L12.5862 12L9.20334 8.63124C8.59889 8.02931 8.59889 7.05338 9.20334 6.45145C9.80778 5.84952 10.7878 5.84952 11.3922 6.45145L15.7452 10.7863ZM15.0487 12.5202C15.3372 12.2329 15.3372 11.7671 15.0487 11.4798L10.6958 7.14502C10.476 6.92613 10.1196 6.92613 9.8998 7.14502C9.68001 7.3639 9.68001 7.71878 9.8998 7.93767L13.9791 12L9.8998 16.0623C9.68 16.2812 9.68 16.6361 9.8998 16.855C10.1196 17.0739 10.476 17.0739 10.6958 16.855L15.0487 12.5202Z"
      fill="#0B1421"
    />
  </SvgIcon>
);

export default TrailingArrow;
